export default function (axios) {
  return {
    // /esign/getCompanyTxSignStatus   获取用户的企业腾讯电子签开通状态
    getCompanyTxSignStatus() {
      return axios.get("/esign/getCompanyTxSignStatus");
    },
  }
}